import Nullstack from 'nullstack';
export default function IconHierarchy3({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-hierarchy-3",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M5 17l2 -3"
  }), "   ", Nullstack.element("path", {
    d: "M9 10l2 -3"
  }), "   ", Nullstack.element("path", {
    d: "M13 7l2 3"
  }), "   ", Nullstack.element("path", {
    d: "M17 14l2 3"
  }), "   ", Nullstack.element("path", {
    d: "M15 14l-2 3"
  }), "   ", Nullstack.element("path", {
    d: "M9 14l2 3"
  }), " ");
}